var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fit" },
    [
      _c("Grid", {
        attrs: {
          id: "certificatesListGrid",
          module: _vm.module,
          data: _vm.certificates,
          "rows-per-page-options": [0],
          columns: _vm.columnOptions,
          onRequest: _vm.fetchClass,
          onExport: _vm.fetchClass,
          onDownload: _vm.onSelectDownload,
          onPrint: _vm.printOneOrMoreCertificates
        },
        scopedSlots: _vm._u([
          {
            key: "header-left",
            fn: function(props) {
              return _vm.canPrintCertificates
                ? [
                    _c(
                      "q-btn",
                      {
                        attrs: {
                          icon: "fa fa-list-alt",
                          size: "md",
                          outline: "",
                          color: "green",
                          label: "Download All",
                          loading: _vm.loadingCertificates
                        },
                        on: {
                          click: function($event) {
                            _vm.downloadAllCertificates()
                          }
                        }
                      },
                      [
                        _c("q-spinner-puff", {
                          attrs: { slot: "loading" },
                          slot: "loading"
                        })
                      ],
                      1
                    ),
                    _vm.$p(["ADMIN"])
                      ? _c(
                          "q-btn",
                          {
                            staticStyle: { "margin-left": "0.5em" },
                            attrs: {
                              icon: "fa fa-print",
                              size: "md",
                              outline: "",
                              color: "purple",
                              loading: _vm.loadingCertificates
                            },
                            on: {
                              click: function($event) {
                                _vm.printAllCertificates()
                              }
                            }
                          },
                          [
                            _c(
                              "q-tooltip",
                              {
                                attrs: {
                                  anchor: "bottom middle",
                                  offset: [0, 50]
                                }
                              },
                              [_vm._v("Print All")]
                            ),
                            _c("q-spinner-puff", {
                              attrs: { slot: "loading" },
                              slot: "loading"
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                : undefined
            }
          },
          {
            key: "col-item-printed",
            fn: function(props) {
              return [
                _c(
                  "i",
                  {
                    staticClass: "fa",
                    class: {
                      "fa-minus text-purple": props.value == 2,
                      "fa-check text-green": props.value == 1,
                      "fa-close text-red": props.value == 0
                    },
                    staticStyle: { "font-size": "20px" }
                  },
                  [
                    props.value == 2
                      ? _c(
                          "q-tooltip",
                          {
                            attrs: { anchor: "bottom middle", offset: [0, 50] }
                          },
                          [
                            _vm._v(
                              "\n          Printing Not Required\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _c("iframe", { ref: "pdfFrame", staticStyle: { display: "none" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }